export default __webpack_public_path__ + "28a8b1d7cac9b1ed5d821bee78ae5870.png";